import { FC } from 'react';
import Button from 'react-bootstrap/Button';
import Accordion from 'react-bootstrap/Accordion';
import { useTranslate } from 'hooks/useTranslate';

type Props = {
  order: string;
  societyId: string;
  isActive: boolean;
};

const DashboardMenu: FC<Props> = ({ order, societyId, isActive }) => {
  const { t } = useTranslate();

  const goToDashboard = () => {
    window.location.href = `#/sociedad/${societyId}`;
  };

  return (
    <Accordion.Toggle as={Button} variant="link" eventKey={order}>
      <li
        className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}
        onClick={goToDashboard}
      >
        <a className="nk-menu-link nk-menu-toggle">
          <span className="nk-menu-icon">
            <em className="icon ni ni-meter" />
          </span>
          <span className="nk-menu-text">{t('Dashboard')}</span>
        </a>
      </li>
    </Accordion.Toggle>
  );
};

export default DashboardMenu;
